import { RefObject, useEffect, useRef, useState } from 'react';
import SignaturePad from 'signature_pad';

interface UseSignatureOptions {
  canvasRef: RefObject<HTMLCanvasElement> | RefObject<undefined>;
}

const useSignature = (options: UseSignatureOptions) => {

  const [ui, uiSet] = useState(undefined as undefined | 'touched' | 'invalid');
  const ref = useRef({
    ui,
    pad: undefined as undefined | SignaturePad,
    onUI: () => {},
  });

  ref.current.onUI = () => {
    if (ref.current.ui !== 'touched') {
      ref.current.ui = 'touched';
      uiSet(ref.current.ui);
    }
  };

  useEffect(() => {
    const canvasElement = options.canvasRef.current;
    const onUI = ref.current.onUI;
    if (canvasElement) {
      ref.current.pad = new SignaturePad(canvasElement);
      canvasElement.addEventListener('click', onUI);
      canvasElement.addEventListener('touchstart', onUI);
    }
    return () => {
      if (canvasElement) {
        canvasElement.removeEventListener('click', onUI);
        canvasElement.removeEventListener('touchstart', onUI);
      }
    };
  }, [options.canvasRef]);


  return {
    clear: () => {
      ref.current.ui = undefined;
      uiSet(ref.current.ui);
      ref.current.pad?.clear();
    },
    toBase64: () => {
      const [_, base64DataString] = (ref.current.pad?.toDataURL('image/base64') || '').split('base64,');
      return base64DataString;
    },
    ui
  };
};

export { useSignature };
